import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import { moduleDefinition } from "@src/config/moduleDefinition";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModuleSelectorModal',
  emits: ["close", "select"],
  setup(__props, { emit }) {


const isModalVisible = ref(true);

function close(): void {
  emit("close");
}

function selectModule(index: number): void {
  emit("select", moduleDefinition[index].name);
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: isModalVisible.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isModalVisible).value = $event)),
    width: "auto",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createTextVNode(" Select module ")
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_list, {
            style: {"max-height":"400px"},
            class: "overflow-y-auto"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(moduleDefinition), (item, i) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: i,
                  value: item,
                  color: "primary",
                  onClick: ($event: any) => (selectModule(i))
                }, {
                  default: _withCtx(() => [
                    _createCommentVNode("          <template v-slot:prepend>"),
                    _createCommentVNode("            <v-img"),
                    _createCommentVNode("              class=\"mr-2\""),
                    _createCommentVNode("              :width=\"100\""),
                    _createCommentVNode("              :height=\"70\""),
                    _createCommentVNode("              cover"),
                    _createCommentVNode("              :src=\"item.imageUrl\""),
                    _createCommentVNode("            />"),
                    _createCommentVNode("          </template>"),
                    _createVNode(_component_v_list_item_title, {
                      textContent: _toDisplayString(item.title)
                    }, null, 8 /* PROPS */, ["textContent"]),
                    _createVNode(_component_v_list_item_subtitle, {
                      textContent: _toDisplayString(item.description)
                    }, null, 8 /* PROPS */, ["textContent"])
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "onClick"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                color: "secondary",
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancel")
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]))
}
}

})